var toString = Object.prototype.toString

module.exports = isString

function isString(obj) {
    return toString.call(obj) === "[object String]"
}



//////////////////
// WEBPACK FOOTER
// ./~/x-is-string/index.js
// module id = 347
// module chunks = 170434399708630 202660965941462